/**
 * @module filters 全局过滤器
 */
const filters = {

    /**
     * @function FilterTime 日期时间格式
     * 
     * @param {string} time
     * @returns 
     */
    FilterTime: (time) => {
        let datatime = time.replace("T", " ")
        return datatime.substring(0, time.indexOf("."))
    },

    /**
     * @function FilterexText DOM解析纯文本
     * 
     * @param {string} htmlString
     * @returns 
     */
    FilterexText: (htmlString) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || '';
    },
}

export default { filters }